import { render } from "./MissingRole.vue?vue&type=template&id=19325a56&scoped=true"
import script from "./MissingRole.vue?vue&type=script&lang=js"
export * from "./MissingRole.vue?vue&type=script&lang=js"

import "./MissingRole.vue?vue&type=style&index=0&id=19325a56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19325a56"]])

export default __exports__